import { Form } from "@circle-react-uikit/Form";
import { Loader } from "@circle-react-uikit/Loader";
import { BasicInfo } from "@circle-react/components/SpaceGroups/NewFormV3/BasicInfo";
import { Permissions } from "@circle-react/components/SpaceGroups/NewFormV3/Permissions";
import { SpaceAccess } from "@circle-react/components/SpaceGroups/NewFormV3/SpaceAccess";
import type { DeepPartial } from "react-hook-form";

import { Moderators } from "./Moderators";
import type { EditSpaceGroupFormValues } from "./types";

interface EditSpaceGroupFormV3Props {
  defaultValues: DeepPartial<EditSpaceGroupFormValues>;
  formId: string;
  loading?: boolean;
  onSubmit: (values: EditSpaceGroupFormValues) => void;
}

export const EditSpaceGroupFormV3 = ({
  formId,
  onSubmit,
  defaultValues,
  loading = false,
}: EditSpaceGroupFormV3Props) => {
  if (loading) return <Loader />;

  return (
    <Form<EditSpaceGroupFormValues>
      id={formId}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      formClassName="flex flex-col gap-4"
    >
      <BasicInfo />
      <Moderators />
      <Permissions />
      <SpaceAccess />
    </Form>
  );
};
